import React, { useState } from "react";
import { Formik, useFormikContext } from "formik";
import { Switch } from "@headlessui/react";
import _ from "lodash";
import { useQuery, gql, useMutation } from "@apollo/client";
// import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import BeneficiarySearchNSelect from "../../../Eligibility/components/requestEligibility/BeneficiarySearchNSelect";
import gqlProviders from "../../../../gql/providers";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../../shared/CustomFilterInput";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ClaimsInfo({ onChange, refId }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [providers, setProviders] = useState([]);
  const [subTypes, setSubTypes] = useState([
    { id: "op", name: t("OutPatient") },
    { id: "ip", name: t("InPatient") },
    { id: "emr", name: t("Emergency") },
  ]);

  const [priorities, setPriorities] = useState([
    { id: "stat", name: t("Stat") },
    { id: "normal", name: t("Normal") },
    { id: "deferred", name: t("Deferred") },
  ]);

  React.useEffect(() => {
    if (
      values.offlinePreAuthNo != "" &&
      values.offlinePreAuthDate == "" &&
      values.dateOrdered
    ) {
      setFieldValue("offlinePreAuthDate", values.dateOrdered);
    }
  }, [
    values.offlinePreAuthNo,
    values.offlinePreAuthDate,
    values.dateOrdered,
    setFieldValue,
  ]);

  const formatProvidersData = (data) => {
    let returnData = [];
    if (data?.length > 0) {
      data.map((item) => {
        returnData.push({
          id: item.id,
          name: item.NameEn,
        });
      });
    } else {
    }
    return returnData;
  };

  // const {
  //   loading: loadingProviders,
  //   error: errorProvider,
  //   data: providersData,
  //   refetch,
  // } = useQuery(gqlProviders.GET_ALL_PROVIDERS_WITHOUT_PAGINATION);

  // React.useEffect(() => {
  //   if (providersData) {
  //     setProviders(formatProvidersData(providersData?.getAllProviders?.data));
  //   }
  // }, [providersData]);

  const payers = [
    {
      id: 1,
      nameAR: "شركة بوبا العربية للتأمين التعاوني",
      nameEN: "Bupa Arabia for Cooperative Insurance",
    },
    {
      id: 2,
      nameAR: "شركة بوبا العربية للتأمين التعاوني",
      nameEN: "Cooperative Company for Cooperative Insurance",
    },
    {
      id: 3,
      nameAR: "شركة بوبا العربية للتأمين التعاوني",
      nameEN: "Al-Rajhi Company for Cooperative Insurance",
    },
  ];

  const statuses = [
    { id: 1, name: "Processing Complete" },
    { id: 2, name: "Error" },
  ];

  const types = [
    { id: "institutional", name: t("Institutional") },
    { id: "oral", name: t("Dental") },
    { id: "pharmacy", name: t("Pharmacy") },
    { id: "professional", name: t("Professional") },
    { id: "vision", name: t("Optical") },
  ];

  // const handleSubType = (val) => {
  //   if (val == "institutional") {
  //     setFieldValue("subType", "ip");
  //     setSubTypes([
  //       { id: "ip", name: "InPatient" },
  //       { id: "emr", name: "Emergency" },
  //     ]);
  //   } else {
  //     setFieldValue("subType", "op");
  //     setSubTypes([{ id: "op", name: "OutPatient" }]);
  //   }
  // };
  const handleSubType = (val) => {
    if (val == "institutional") {
      setFieldValue("subType", "ip");
      setSubTypes([{ id: "ip", name: t("InPatient") }]);
    } else if (val == "professional") {
      setFieldValue("subType", "op");
      setSubTypes([
        { id: "op", name: t("OutPatient") },
        { id: "emr", name: t("Emergency") },
      ]);
    } else {
      setFieldValue("subType", "op");
      setSubTypes([{ id: "op", name: t("OutPatient") }]);
    }
  };

  const addData = (values) => {
    // setShowEligibilityModal(false);
    let data = _.cloneDeep(values);
    console.log("data :: ", data);
    // checkEligibility({ variables: { input: data } });
  };
  const formikRef = React.useRef();
  React.useImperativeHandle(refId, () => ({
    Submit: async () => {
      await formikRef.current.submitForm();
    },
  }));

  function watchForm(data) {
    if (onChange) {
      onChange({
        values: data,
      });
    }
  }
  return (
    <>
      <div class="personal-data !p-2 !mb-2 ">
        <div class="personal-title !mb-3">
          <div class="inventory-svg">
            <svg
              width="26"
              height="26"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
              <path
                d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                fill="#0070C2"
              ></path>
              <path
                d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                fill="#0070C2"
              ></path>
            </svg>
          </div>
          <div class="personal-head">
            <span>{t("Claim Info")}</span>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-1.5">
          <CustomFilterInput
            label={t("Date Ordered*")}
            name="dateOrdered"
            type="date"
            value={values.dateOrdered}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.dateOrdered ? errors.dateOrdered : null}
            touched={touched.dateOrdered}
          />

          <CustomFilterInput
            label={t("Claim Type*")}
            name="claimType"
            isSelect={true}
            placeholder={t("Select Type")}
            options={types}
            value={values.claimType}
            onChange={(e) => {
              setFieldValue("claimType", e.target.value);
              handleSubType(e.target.value);
              if(e.target.value=="institutional"){
                setFieldValue("adminSource","IA")
                setFieldValue("intendedLengthOfStay","ISD")
              }
            }}
            onBlur={handleBlur}
            error={touched.claimType ? errors.claimType : null}
            touched={touched.claimType}
          />

          <CustomFilterInput
            label={t("Sub Type")}
            name="subType"
            isSelect={true}
            placeholder={t("Select Sub Type")}
            options={subTypes}
            value={values.subType}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.subType ? errors.subType : null}
            touched={touched.subType}
          />

          <CustomFilterInput
            label={t("Offline Eligibility Id")}
            name="offlineEligibilityId"
            placeholder={t("Offline Eligibility ID")}
            value={values.offlineEligibilityId}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched.offlineEligibilityId ? errors.offlineEligibilityId : null
            }
            touched={touched.offlineEligibilityId}
          />

          <CustomFilterInput
            label={t("Offline Eligibility Date")}
            name="offlineEligibilityDate"
            type="date"
            value={values.offlineEligibilityDate}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched.offlineEligibilityDate
                ? errors.offlineEligibilityDate
                : null
            }
            touched={touched.offlineEligibilityDate}
          />

          <CustomFilterInput
            label={t("Eligibility Response (Value)")}
            name="eligibilityResponseIdentifierValue"
            placeholder={t("Identifier Value")}
            value={values.eligibilityResponseIdentifierValue}
            onChange={handleChange}
            error={
              touched.eligibilityResponseIdentifierValue
                ? errors.eligibilityResponseIdentifierValue
                : null
            }
            touched={touched.eligibilityResponseIdentifierValue}
          />

          <CustomFilterInput
            label={t("Eligibility Response (URL)")}
            name="eligibilityResponseIdentifierUrl"
            placeholder={t("Identifier URL")}
            value={values.eligibilityResponseIdentifierUrl}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched.eligibilityResponseIdentifierUrl
                ? errors.eligibilityResponseIdentifierUrl
                : null
            }
            touched={touched.eligibilityResponseIdentifierUrl}
          />

          <CustomFilterInput
            label={t("PreAuth Response (Value)")}
            name="preAuthRespValue"
            placeholder={t("PreAuth Res. Value")}
            value={values.preAuthRespValue}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.preAuthRespValue ? errors.preAuthRespValue : null}
            touched={touched.preAuthRespValue}
          />

          <CustomFilterInput
            label={t("PreAuth Response (URL)")}
            name="preAuthRespUrl"
            placeholder={t("PreAuth Res. URL")}
            value={values.preAuthRespUrl}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.preAuthRespUrl ? errors.preAuthRespUrl : null}
            touched={touched.preAuthRespUrl}
          />

          <CustomFilterInput
            label={t("Episode No*")}
            name="episodeNo"
            placeholder={t("Episode No.")}
            value={values.episodeNo}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.episodeNo ? errors.episodeNo : null}
            touched={touched.episodeNo}
          />

          <CustomFilterInput
            label={t("Approval Number")}
            name="preAuthRefNo"
            placeholder={t("Reference No(s)")}
            value={values.preAuthRefNo}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.preAuthRefNo ? errors.preAuthRefNo : null}
            touched={touched.preAuthRefNo}
          />

          <CustomFilterInput
            label={t("Referral Number")}
            name="offlinePreAuthNo"
            placeholder={t("Offline Reference No(s)")}
            value={values.offlinePreAuthNo}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.offlinePreAuthNo ? errors.offlinePreAuthNo : null}
            touched={touched.offlinePreAuthNo}
          />

          <CustomFilterInput
            label={t("Referral Date")}
            name="offlinePreAuthDate"
            type="date"
            value={values.offlinePreAuthDate}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.offlinePreAuthDate ? errors.offlinePreAuthDate : null}
            touched={touched.offlinePreAuthDate}
          />

          <CustomFilterInput
            label={t("Ref. Provider")}
            name="referringProvider"
            isSelect={true}
            placeholder={t("Select Provider")}
            options={providers}
            value={values.referringProvider}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <CustomFilterInput
            label={t("Priority")}
            name="priority"
            isSelect={true}
            placeholder={t("Select Priority")}
            options={priorities}
            value={values.priority}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
      </div>
    </>
  );
}

export default ClaimsInfo;
